import React from 'react';
import { CorporateRegistration } from '@js/components/corporateRegistrations/CorporateRegistration';
import { CorporateRepresentative } from '@js/components/corporateRegistrations/CorporateRepresentative';
import { CorporateOwner } from '@js/components/corporateRegistrations/CorporateOwner';
import { CorporateCompatibility } from '@js/components/corporateRegistrations/CorporateCompatibility';
import { CorporateBankAccount } from '@js/components/corporateRegistrations/CorporateBankAccount';
import { CorporateIdentificationTypeSelection } from '@js/components/corporateRegistrations/Identification/CorporateIdentificationTypeSelection';
import { CorporateIdentification } from '@js/components/corporateRegistrations/Identification/CorporateIdentification';
import { SnsAuth } from '@js/components/snsAuths/SnsAuth';

export const routes = [
  {
    path: '/',
    children: <CorporateRegistration />,
    exact: true
  },
  {
    path: '/representative',
    children: <CorporateRepresentative />,
    exact: true
  },
  {
    path: '/owner',
    children: <CorporateOwner />,
    exact: true
  },
  {
    path: '/compatibility',
    children: <CorporateCompatibility />,
    exact: true
  },
  {
    path: '/bank_account',
    children: <CorporateBankAccount />,
    exact: true
  },
  {
    path: '/identity_verification_type',
    children: <CorporateIdentificationTypeSelection />,
    exact: false
  },
  {
    path: '/identification',
    children: <CorporateIdentification />,
    exact: false
  }
];

export const snsAuthRoutes = [
  {
    path: '/login',
    children: <SnsAuth />,
    exact: true
  },
  {
    path: '/customers/new',
    children: <SnsAuth />,
    exact: true
  },
];
